<div class="pro-widget">

  <div class="pro-widget__content">
    <div class="corr">
      <div class="corr__headers">

        <div class="corr__header-left" [style.color]="(isActual() ? colors[0] : colors[1]) + ' !important'">{{title()}}
        </div>

        @if(kpiDialogInformationId() && !isPrinting()){
        <app-info-icon-dialog class="header_info"
          [dialogInformationId]="kpiDialogInformationId()"></app-info-icon-dialog>
        }
      </div>
      <div class="line-separator"></div>
      <div class="kpiContainer">
        <ng-container #content></ng-container>
      </div>

      <div class="corr__chart">
        <div #chart echarts [options]="chartOptions" [merge]="updateOptions" [initOpts]="initOptions"
          (chartInit)="onChartInit($event)" class="visual"></div>
        <app-chart-info-box [information]="information()"
          [dialogInformationId]="dialogInformationId()"></app-chart-info-box>
      </div>
    </div>
  </div>
</div>